import mitt from 'mitt';
import type { Emitter } from 'mitt';
import type { DreEvent, PickerMode } from './usePicker';

type PickerRecord = Record<PickerMode, DreEvent>;
type PickerModeEmitter = Emitter<PickerRecord>;

const emitters: {
  [key: string]: PickerModeEmitter;
} = {};

const getEmitter = (viewportId: string) => {
  if (emitters[viewportId] != null) {
    return emitters[viewportId];
  } else {
    const emitter = mitt<PickerRecord>();
    emitters[viewportId] = emitter;
    return emitter;
  }
};

export const emitter: PickerModeEmitter | null = null;

/**
 * Used to trigger events in unit tests, the real implementation is defined
 * in `__mocks__/useEmitter.js` and becomes available only after the module
 * is mocked by calling `jest.mock('./useEmitter')`.
 * Note that the mock doesn't support multiple emitter instances.
 */
export const sendTestEvent = (type: PickerMode, event: unknown): void =>
  console.error(
    '`sendTestEvent` is meant to be used only in unit tests, did you forget to mock `useEmitter`?'
  );

/**
 * On DRE we use one emitter for each viewport rather than one emitter for all
 * like it happens on the EventsManager module, this is because we want the
 * events to be scoped by viewport, and we don't care about the cross-window
 * functionalities provided by EventsManager.
 * This approach helps with the overall performance since each viewport has
 * to handle only the events that interest it.
 */
export const useEmitter = (viewportId: string): PickerModeEmitter => {
  const emitter = getEmitter(viewportId);
  return emitter;
};
